<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <form>
    <div class="bg-white rounded-xl p-4 flex items-center gap-4">
      <div class="flex items-center gap-2 w-full">
        <img src="../../assets/image/search.svg" alt="" class="" />
        <input placeholder="Search Concern Type  Here..." class="w-full border p-2 rounded-md outline-none"
          placeholder="Search User" matInput (input)="applyFilter($event)" />
      </div>
     

    
       <div class="w-60">


        <app-primary-button  (click)="openAddUserDialog()" class="flex w-40">
          <div class="flex space-x-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            <span>{{ 'ADD_USER' | translate }}</span>
          </div>
        </app-primary-button>
      </div>
    </div>
  </form>
  <!-- Table -->
  <div class="bg-white rounded-2xl shadow-md p-4">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 w-full">

      <!-- Sr No. -->
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'srNo' | translate }}</th>
        <td mat-cell *matCellDef="let element; let i = index">
          {{ i + 1 }}
        </td>
      </ng-container>

      <!-- Name -->
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NAME' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.full_name | titlecase }}</td>
      </ng-container>

    

   

      <!-- Reason -->
      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef>  {{ 'START_WORKING' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.start_date |  date }}</td>
      </ng-container>
      <!-- Reason -->
      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef>  {{ 'LAST_WORKING' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.end_date |  date }}</td>
      </ng-container>
 <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> {{ 'action' | translate }}</th>
        <td mat-cell *matCellDef="let element">
        
          <button mat-icon-button color="secondary" (click)="openAddUserEditDialog(element)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="accent" >
            <mat-icon>delete</mat-icon>
          </button>
        
        </td>
      </ng-container>
    



      <tr mat-header-row *matHeaderRowDef="displayedColumns" ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    
  <app-empty-data *ngIf="dataSource.data.length < 1" class="justify-center align-items-center"
      [imageSource]="'../../assets/blankScreen/support.png'" [message]="'No data available'"></app-empty-data>
    <mat-paginator [length]="dataSource.data.length" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>

  </div>



</div>